import './GreenTick.scss';

const GreenTick = () => {
  // return <div className='GreenTick'>✔</div>;

  return (
    <div className='completed-badge'>
      <span>COMPLETED</span>
      <div className='checkmark'>&#10003;</div>
    </div>
  );
};
export default GreenTick;
